import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { BodyDefault } from '../../../components/typography/styled'

export const ResourceLink = styled(Link)`
  color: ${({ theme }) => theme.primary[600]};
  text-decoration: none;
  overflow-wrap: anywhere;
  &:hover { text-decoration: underline; }
`

export const Configuration = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-wrap: anywhere;
`

export const PreorderBadge = styled.span<{ $status: string }>`
  display: inline-flex;
  border-radius: 4px;
  padding: 3px 7px;
  font-size: 13px;
  color: ${({ theme, $status }) => $status === 'released' ? theme.success : $status === 'cancelled' ? theme.errors[600] : theme.palette[800]};
  background: ${({ theme }) => theme.palette[200]};
`

export const Note = styled(BodyDefault)`
  color: ${({ theme }) => theme.palette[800]};
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`

export const DiskRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  > div:first-child { flex: 1; min-width: 0; }
`
